// extracted by mini-css-extract-plugin
export default {"homePageCustomers":"HomePageCustomers_homePageCustomers__B7MOt"};